import { render, staticRenderFns } from "./_ConfirmRemoveExpenseDialog.vue?vue&type=template&id=37eb5704"
import script from "./_ConfirmRemoveExpenseDialog.vue?vue&type=script&lang=js"
export * from "./_ConfirmRemoveExpenseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports